import { render } from "./BackerCenterUpdateFeedList.vue?vue&type=template&id=5eed54fa"
import script from "./BackerCenterUpdateFeedList.vue?vue&type=script&lang=js"
export * from "./BackerCenterUpdateFeedList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__